// extracted by mini-css-extract-plugin
export default {"wrapper":"Title_wrapper__3sF3j","text":"Title_text__yiPY8","title":"Title_title__PT3sY"};